@use '@/scss/underscore' as _;

.withTable {
  height: 100%;
}
